import { createAction } from 'redux-actions';
import { subMinutes } from 'date-fns';
import { createReportNotification } from '../reports/actions';
import apiInstance2 from '../../services/apiService';
import { updateRespondentRow, getRespondentById } from '../respondents/actions';
import { fetchRespondent } from '../../api/respondents';

export const fetchAssessmentsChangesStart = createAction('FETCH_ASSESSMENTS_ACTIONS_START');
export const fetchAssessmentsChangesSuccess = createAction('FETCH_ASSESSMENTS_ACTIONS_SUCCESS');
export const fetchAssessmentsChangesFailure = createAction('FETCH_ASSESSMENTS_ACTIONS_FAILURE');

export const fetchAssessmentsChanges = (queryClient) => async (dispatch) => {
  try {
    dispatch(fetchAssessmentsChangesStart());
    const currentDate = new Date();
    const from = subMinutes(currentDate, 1).toISOString();
    const to = currentDate.toISOString();
    const response = await apiInstance2.get(`/api/v2/Notifications/assessments?fromDateTime=${from}&toDateTime=${to}`);
    if (response.status === 200) {
      dispatch(fetchAssessmentsChangesSuccess());
      const uniqueRespondents = [];
      let hasRespondentUpdate = false;
      let hasRespondentCreate = false;
      const filtered = response.data.notifications.filter((not) => {
        if (not.respondentID) {
          if (uniqueRespondents.includes(not.respondentID)) {
            return false;
          }
          uniqueRespondents.push(not.respondentID);
          return true;
        }
        return true;
      });
      filtered.forEach(async (notification) => {
        if (notification.respondentID) {
          fetchRespondent(notification.respondentID).then((data) => {
            queryClient.setQueryData(['respondents'], (oldData = {}) => {
              const isRespondentPresent = (oldData.respondents || []).find(
                (or) => or.respondentID === data.respondentID,
              );
              if (isRespondentPresent) {
                if (!hasRespondentCreate) {
                  hasRespondentCreate = true;
                }
              } else if (!hasRespondentUpdate) {
                hasRespondentUpdate = true;
              }
              return {
                ...oldData,
                respondents: isRespondentPresent
                  ? oldData.respondents?.map((respondent) => {
                      if (respondent.respondentID === data.respondentID) {
                        return data;
                      }
                      return respondent;
                    }) || []
                  : [data, ...(oldData?.respondents || [])],
              };
            });
          });
        }

        const title = 'Assessment has been completed!';
        createReportNotification(notification, { type: 'info', title }, dispatch);
        const respondent = await dispatch(getRespondentById(notification?.respondentID));
        const assessmentDone = notification?.questionnaire;
        if (!assessmentDone || !respondent) return;
        const currentAssessmentsDone = respondent.assessmentsDone;
        if (currentAssessmentsDone.includes(assessmentDone)) return;
        const newState = {
          respondentID: notification.respondentID,
          assessmentsDone: [...currentAssessmentsDone, assessmentDone],
        };
        await dispatch(updateRespondentRow(newState));
      });
    }
  } catch (e) {
    dispatch(fetchAssessmentsChangesFailure(e));
  }
};
